import { FC, lazy } from 'react';

import { Admins } from '@/modules/admins';

export const AdminsPage: FC = () => <Admins />;

export const AdminsPageLazy = lazy(async () => {
    const { AdminsPage } = await import('./page');

    return { default: AdminsPage };
});
